module.exports = __webpack_public_path__ + "media/assets/community_index/collapse-icon-b5b319e6a80d6044517d17b78359e244ca7d2522b01056be23dd6e99ec431212.svg";